import CircleIcon from "@mui/icons-material/Circle";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import {
  Box,
  Grid,
  Modal,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
  styled,
  tableCellClasses,
} from "@mui/material";
import React, { useState } from "react";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { v4 as uuid } from "uuid";
import { AddUserPermissionResponse } from "../../../models/userPermission.model";
import { DeleteUserPermission } from "../../../services/userPermissions.service";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#DAE0E4",
    color: "#1D4A87",
    fontSize: "14px",
    marginBottom: "50px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    color: "#34495E",
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: "#F9FAFC",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
const deactiveUserStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  minWidth: {
    xs: 250,
    sm: 300,
    md: 400,
    lg: "400px",
  },
  maxHeight: "70vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  overflow: "auto",
  overflowX: "hidden",
  paddingRight: "3vh",
  paddingTop: "3vh",
  // direction: "ltr",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};

interface Props {
  permisson: AddUserPermissionResponse;
  setUpdateGetUserPermissions: any;
}

export default function CertificateTableRows({
  permisson,
  setUpdateGetUserPermissions,
}: Props) {
  const [isHovered, setHovered] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [delId, setDelId] = useState<number>();

  const handelDeleteItem = () => {
    DeleteUserPermissionMutate({
      userPermissionId: delId!,
    });
  };

  const { mutate: DeleteUserPermissionMutate } = useMutation(
    DeleteUserPermission,
    {
      onSuccess: (data: boolean) => {
        if (data) {
          setUpdateGetUserPermissions(uuid());
          toast.success("با موفقیت حذف گردید");
          setOpenDeleteModal(false);
        }
      },
      onError: () => {},
    }
  );
  return (
    <>
      <StyledTableRow>
        <StyledTableCell align="center" component="th" scope="row">
          <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
            {permisson.permissionTitle}
          </p>
        </StyledTableCell>
        <StyledTableCell align="center" component="th" scope="row">
          <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
            {permisson.permissionGroupTitle}
          </p>
        </StyledTableCell>
        <StyledTableCell
          align="right"
          sx={{ borderTop: "none !important" }}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
          {!isHovered ? (
            <span
              style={{
                textAlign: "center",
                marginBottom: "-.5vh",
              }}
            >
              <CircleIcon
                style={{
                  color:
                    permisson.accessType === "Deny" ? "#E6123D" : "#01AF43",
                  cursor: "pointer",
                  marginInline: "3px",
                }}
              />
            </span>
          ) : (
            <span
              style={{
                textAlign: "center",
                marginBottom: "-.5vh",
              }}
            >
              <Tooltip arrow title="حذف کردن">
                <DeleteOutlineIcon
                  style={{
                    color: "#9AAFC4",

                    cursor: "pointer",
                    marginInline: "3px",
                  }}
                  onClick={() => {
                    setOpenDeleteModal(true);
                    setDelId(permisson.id);
                  }}
                />
              </Tooltip>
            </span>
          )}
        </StyledTableCell>
      </StyledTableRow>
      <div>
        <Modal
          open={openDeleteModal}
          onClose={() => setOpenDeleteModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={deactiveUserStyle}>
            <Typography
              component={"p"}
              display={"block"}
              textAlign={"center"}
              fontWeight={"bold"}
              marginY={"3rem"}
              fontSize={"14px"}
            >
              آیا از حذف کردن مجوز اختصاصی{" "}
              <span style={{ color: "#E6123D", fontWeight: "bold" }}>
                "{permisson.permissionTitle}"
              </span>{" "}
              اطمینان دارید؟
            </Typography>
            <Grid container justifyContent={"center"} gap={"1rem"}>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={6}
                sx={{
                  backgroundColor: "#E6123D",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                padding={"0.5rem"}
                maxWidth={"150px !important"}
                onClick={() => {
                  handelDeleteItem();
                }}
              >
                <Typography
                  textAlign={"center"}
                  color={"#FFF"}
                  fontWeight={"bold"}
                  // onClick={handleDel}
                >
                  بله
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={6}
                sx={{
                  backgroundColor: "#607D8B",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                padding={"0.5rem"}
                maxWidth={"150px !important"}
              >
                <Typography
                  textAlign={"center"}
                  color={"#FFF"}
                  fontWeight={"bold"}
                  onClick={() => setOpenDeleteModal(false)}
                >
                  خیر
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Modal>
      </div>
    </>
  );
}
